export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">有漫画推荐、合作意向或使用问题？随时联系我们</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-8">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">投稿与合作</h3>
              <p className="text-xs text-foreground-600">contact@xiangxiangmh.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-discuss-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">读者反馈</h3>
              <p className="text-xs text-foreground-600">feedback@xiangxiangmh.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-wechat-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">微信公众号</h3>
              <p className="text-xs text-foreground-600">香香漫画官方</p>
            </div>
          </div>

          <div className="border-t border-background-200/70 pt-6">
            <div className="flex flex-wrap justify-center gap-3">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-weibo-line text-sm"></i> 微博 @香香漫画
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-bilibili-line text-sm"></i> B站 香香漫画官方
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-tiktok-line text-sm"></i> 抖音 香香漫画
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600 bg-background-100 px-3 py-1.5 rounded-full">
                <i className="ri-reddit-line text-sm"></i> 小红书 香香漫画推荐
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}